"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UnableToFetchIpInfoError extends client_library_1.ExtendableError {
    constructor(message) {
        super(`Unable to fetch IP info: ${message}`);
    }
}
exports.default = UnableToFetchIpInfoError;
